import { Component, OnInit } from '@angular/core';
import { MyauthService } from 'src/app/services/myauth.service';

@Component({
  selector: 'app-pwreset',
  templateUrl: './pwreset.component.html',
  styleUrls: ['./pwreset.component.css']
})
export class PwresetComponent implements OnInit {

  constructor(private myauth:MyauthService) { }

  ngOnInit(): void {
  }

}
